<!--
/**
 * 骨架屏组件 - Skeleton
 *
 * 功能描述：
 * 1. 展示内容加载时的动态占位图形
 *
 * Props
 * aspectRatio {string} [null] - 宽高比（格式："宽度/高度"），设置后自动计算高度
 * width {string} ['100%'] - 骨架宽度（支持CSS单位）
 * height {string} ['20px'] - 默认高度（未设置宽高比时生效）
 * delay {number} [null] - 独立延迟基数（覆盖容器配置）
 *
 * 使用示例:
 * <Skeleton width="60%" height="24px" />
 * <Skeleton aspect-ratio="1" :delay="3" />
 *
 * 布局说明:
 * - 多个骨架组件垂直排列时自动保持 8px 间距
 */
-->
<template>
  <div
    class="skeleton"
    :style="{ width, aspectRatio, height: aspectRatio ? 'auto' : height, animationDelay: `calc(${delay} * 100ms)` }"
  />
</template>

<script setup>
const props = defineProps({
  aspectRatio: {
    type: String,
    default: null
  },
  width: {
    type: String,
    default: '100%'
  },
  height: {
    type: String,
    default: '20px'
  },
  delay: {
    type: Number,
    default: null
  }
})

const skeleton = inject('skeleton')

const delay = computed(() => props.delay ?? skeleton.delay)
</script>

<style lang="less">
.skeleton {
  border-radius: 4px;
  animation: skeleton-animate 1.3s cubic-bezier(0.4,0,0.2,1) infinite forwards;

  + .skeleton {
    margin-top: 8px;
  }

  @keyframes skeleton-animate {
    0% {
      background-color: #EBEBEB;
    }
    25% {
      background-color: #F8F8F8;
    }
    80% {
      background-color: #EBEBEB;
    }
    100% {
      background-color: #EBEBEB;
    }
  }
}
</style>
